module.exports = __webpack_public_path__ + "static/media/11.064806c4.png";